import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLocation = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 17 17",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(0.25 0.25)",
		children: [/* @__PURE__ */ _jsx("circle", {
			cx: 8.2,
			cy: 6.8,
			r: 3,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M14.2,6.8c0,5.3-4.6,8.2-5.8,8.9c-0.2,0.1-0.3,0.1-0.5,0C6.9,15,2.2,12,2.2,6.8 c0-3.3,2.7-6,6-6S14.2,3.5,14.2,6.8z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	})
});
export { SvgLocation as ReactComponent };
